<template>
	<v-app v-if="$vuetify.breakpoint.mdAndUp">
		<v-main style="height:100%;display:flex;flex-direction:column;background-color:black;">
			<v-container style="min-width: 102%;" :style="{'backgroundColor' : $route.path.includes('/training/module') ? this.$store.state.trainingModuleBgColor : 'transparent' }">
				<router-view :key="$route.fullPath"></router-view>
			</v-container>
		</v-main>

		<notification></notification>

		<img v-show="$root.loader.value" src="loader.svg" class="loader" />
	</v-app>
	<plain-mobile v-else></plain-mobile>
</template>

<style scoped>
</style>

<script>
import notification from "./notification.vue";
import plainMobile from "./mobile/plainMobile.vue";
/* eslint-disable no-console */
export default {
	components: {
		notification,
		plainMobile
	},
	data() {
		return {};
	},
	methods: {},
};
</script>
